export default {"src":"/_next/static/media/icon-app-store.420b3523.svg","height":35,"width":108,"blurWidth":0,"blurHeight":0};